
import React from 'react';

export default function Approach() {
    return (
        <section className="py-24 md:py-32 px-6 md:px-20 lg:px-40 bg-white text-black" data-header-theme="dark">
            <div className="container mx-auto">
                <div className="flex flex-col gap-12 md:gap-16">
                    {/* Header: Label + Title */}
                    <div className="flex flex-col gap-6">
                        <span className="text-[15px] font-semibold uppercase tracking-widest text-[#1C1C1C]">
                            Approach
                        </span>
                        <h2 className="text-[50px] md:text-[80px] font-medium leading-[0.95] tracking-tight text-[#1C1C1C]">
                            Method of making<br />
                            better result
                        </h2>
                    </div>

                    {/* Steps Flex Layout */}
                    <div className="flex flex-col md:flex-row justify-between gap-6 md:gap-4 relative">

                        {/* Step 1 */}
                        <div className="min-w-0 relative bg-[#F8F9FA] md:bg-transparent p-8 md:p-0 rounded-[28px] md:rounded-none">
                            <div className="absolute top-8 right-8 text-[48px] font-bold text-gray-200/60 md:hidden leading-none select-none">01</div>
                            <h3 className="text-[28px] md:text-[32px] font-medium leading-[1.1] mb-6 text-[#1C1C1C] whitespace-pre-line tracking-tight pr-12 md:pr-0">
                                Problem{"\n"}discovery
                            </h3>

                            <ul className="flex flex-col gap-3 md:gap-2 pl-0 m-0 list-none">
                                {["Usability Studies", "User Interviews", "Stakeholder Interviews", "Competitive Research", "Insights Report", "User Journey"].map((item, i) => (
                                    <li key={i} className="text-[16px] md:text-[17px] text-[#4A4A4A] md:text-[#1C1C1C] leading-[1.5] font-normal flex md:block items-start">
                                        <span className="mt-2.5 mr-3 w-1.5 h-1.5 rounded-full bg-gray-300 md:hidden shrink-0"></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Arrow 1 */}
                        <div className="hidden md:flex shrink-0 items-start justify-center w-[120px] lg:w-[150px] pt-[34px] px-2">
                            <img
                                src="https://wp.ravextheme.com/redox/wp-content/uploads/2025/05/ax-long-arrow-icon.webp"
                                alt=""
                                className="w-full h-auto object-contain"
                            />
                        </div>

                        {/* Step 2 */}
                        <div className="min-w-0 relative bg-[#F8F9FA] md:bg-transparent p-8 md:p-0 rounded-[28px] md:rounded-none">
                            <div className="absolute top-8 right-8 text-[48px] font-bold text-gray-200/60 md:hidden leading-none select-none">02</div>
                            <h3 className="text-[28px] md:text-[32px] font-medium leading-[1.1] mb-6 text-[#1C1C1C] whitespace-pre-line tracking-tight pr-12 md:pr-0">
                                Design{"\n"}system ready
                            </h3>

                            <ul className="flex flex-col gap-3 md:gap-2 pl-0 m-0 list-none">
                                {["Thinking Workshops", "Sitemaps", "Concepts", "Designs", "Prototypes", "Usability Studies"].map((item, i) => (
                                    <li key={i} className="text-[16px] md:text-[17px] text-[#4A4A4A] md:text-[#1C1C1C] leading-[1.5] font-normal flex md:block items-start">
                                        <span className="mt-2.5 mr-3 w-1.5 h-1.5 rounded-full bg-gray-300 md:hidden shrink-0"></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Arrow 2 */}
                        <div className="hidden md:flex shrink-0 items-start justify-center w-[120px] lg:w-[150px] pt-[34px] px-2">
                            <img
                                src="https://wp.ravextheme.com/redox/wp-content/uploads/2025/05/ax-long-arrow-icon.webp"
                                alt=""
                                className="w-full h-auto object-contain"
                            />
                        </div>

                        {/* Step 3 */}
                        <div className="min-w-0 relative bg-[#F8F9FA] md:bg-transparent p-8 md:p-0 rounded-[28px] md:rounded-none">
                            <div className="absolute top-8 right-8 text-[48px] font-bold text-gray-200/60 md:hidden leading-none select-none">03</div>
                            <h3 className="text-[28px] md:text-[32px] font-medium leading-[1.1] mb-6 text-[#1C1C1C] whitespace-pre-line tracking-tight pr-12 md:pr-0">
                                Design{"\n"}implementation
                            </h3>

                            <ul className="flex flex-col gap-3 md:gap-2 pl-0 m-0 list-none">
                                {["Design", "Use Cases", "User Flows", "Various User Types", "Annotations", "Interactions"].map((item, i) => (
                                    <li key={i} className="text-[16px] md:text-[17px] text-[#4A4A4A] md:text-[#1C1C1C] leading-[1.5] font-normal flex md:block items-start">
                                        <span className="mt-2.5 mr-3 w-1.5 h-1.5 rounded-full bg-gray-300 md:hidden shrink-0"></span>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}
